const s = {
  shouldForwardProp: (t) => !t.startsWith("$")
};
export {
  s as t
};
//# sourceMappingURL=transient-options-DbpnFyL2.mjs.map
